// test1860
(1860 && 0);
